<template>
  <div>
    <NotFound v-if="show404" return-path-name="find-symptoms" />
    <div class="container" v-else>
      <div class="row" v-if="isLoading">
        <div class="d-flex justify-content-center">
          <Loading />
        </div>
      </div>
      <div class="fault" v-else>
        <h5>Usterka</h5>
        <h1 class="intro-text">
          <strong>{{ fault.name }}</strong>
        </h1>
        <h6 v-if="fault.variant">
          Wariant: <strong>{{ fault.variant }}</strong>
        </h6>
        <importances :importances="fault.importances" />
        <symptoms :symptoms="fault.symptoms" />
        <causes v-if="fault.causes" :causes="fault.causes" />
        <diy v-if="fault.diy" :diy="fault.diy" />
        <parts :parts="fault.parts" />

        <div class="row mt-2 ms-1 me-1">
          <section-header>Rozwiązanie / naprawa</section-header>
        </div>
        <repair
          v-for="repair in fault.repairs"
          :key="repair.id"
          :repair="repair"
        />
      </div>
      <mail-to-us
        bold-text="Zapytaj eksperta o twój problem z samochodem?"
        small-text="Prześlij nam informację"
        :type="FormTypes.GENERAL"
      />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/components/Loading";
import Importances from "@/components/fault-detail-components/Importances";
import Symptoms from "@/components/fault-detail-components/Symptoms";
import Causes from "@/components/fault-detail-components/Causes";
import Diy from "@/components/fault-detail-components/Diy";
import Parts from "@/components/fault-detail-components/Parts";
import Repair from "@/components/fault-detail-components/Repair";
import SectionHeader from "@/components/fault-detail-components/SectionHeader";
import NotFound from "@/views/NotFound";
import MailToUs from "@/improvementForms/MailToUs";
import { FormTypes } from "@/improvementForms/formTypes";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    NotFound,
    MailToUs,
    Repair,
    Parts,
    Diy,
    Causes,
    Symptoms,
    Importances,
    Loading,
    SectionHeader,
  },
  data: function () {
    return {
      isLoading: false,
      fault: {},
      show404: false,
      FormTypes,
    };
  },
  mounted() {
    this.isLoading = true;
    if (this.getInitObject.object) {
      this.fault = this.getInitObject.object;
      document.title = this.fault.name;
      this.isLoading = false;
      this.resetInitObject();
    } else {
      axios
        .get(`/api/faults/faults/${this.$route.params.faultId}/`)
        .then((response) => {
          this.fault = response.data;
          document.title = this.fault.name;
          this.isLoading = false;
        })
        .catch((reason) => {
          if (reason.response.status === 404) {
            this.show404 = true;
          } else {
            console.error(reason);
          }
        });
    }
  },
  computed: {
    ...mapGetters(["getInitObject"]),
  },
  methods: {
    ...mapMutations(["resetInitObject"]),
  },
};
</script>
<style>
.list-p-margin ul li p {
  margin-bottom: 8px;
}
</style>
<style scoped>
h5 {
  font-family: Comfortaa-light, serif;
  color: gray;
}

h1,
h6 {
  font-family: Roboto, sans-serif;
}

.header {
  font-size: 3vh;
  border-bottom: 1px black solid;
}
</style>
